const PERMISSION_KEY= "personalize:portfolio_list";
const PAGE_URL = {
    PORTFOLIO_LIST_PAGE: "/admin/personalize/portfolio-list",
    PORTFOLIO_LIST_INTEGRATION_PAGE: "/admin/personalize/portfolio-list-integration"
}

export {PERMISSION_KEY, PAGE_URL}

